import { Component, OnInit, OnDestroy } from '@angular/core';
import { ProductService } from 'src/app/shared/services/product.service';
import { IPolizaVitalicia } from 'src/app/shared/Entities/entities';
import { Subscription } from 'rxjs';
import { EventsService } from 'src/app/shared/services/events.service';

@Component({
  selector: 'app-seguro-privado-resumen',
  templateUrl: './seguro-privado-resumen.component.html',
  styleUrls: ['./seguro-privado-resumen.component.sass'],
})
export class SeguroPrivadoResumenComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  resumenes: IPolizaVitalicia[] = [];

  constructor(
    private productSrv: ProductService,
    private eventsSrv: EventsService
  ) {}

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  ngOnInit() {
    const subs = this.productSrv
      .listarLineaNegocio()
      .subscribe(lineasNegocios => {
        if (!lineasNegocios) {
          return;
        }
        const lineaVitalicia = lineasNegocios.find(
          l => l.LineaNegocio === 'RENTAS VITALICIAS'
        );
        if (!lineaVitalicia) {
          return;
        }
        const listaProdSubs = this.productSrv
          .obtenerResumenVitalicia()
          .subscribe(resumen => {
            this.resumenes = resumen;

            const menuRoot = this.eventsSrv.getMenu();
            const menu = menuRoot.items.find(x => x.route.path === 'privado');
            menu.active = true;
            this.resumenes.forEach(r => {
              menu.children.find(
                x => x.id.toString() === r.Numero
              ).route.params = {
                tipo: r.Tipo,
                numPersona: r.Numero_persona,
              };
            });
          });
        this.subscriptions.push(listaProdSubs);
      });

    this.subscriptions.push(subs);
  }
}
